import { render, staticRenderFns } from "./Association.vue?vue&type=template&id=e4b48b88&scoped=true"
import script from "./Association.vue?vue&type=script&lang=js"
export * from "./Association.vue?vue&type=script&lang=js"
import style0 from "./Association.vue?vue&type=style&index=0&id=e4b48b88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b48b88",
  null
  
)

export default component.exports